var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { OfferTypes } from '../../../core/types';
import { primaryCalculatorId, selectIncentiveOffers, selectLoyaltyOffer, selectPaymentMethod, selectPrimaryCalculatorLoyaltyOfferKey, selectTermAndRate, } from '../../../core/reducers/financialCalculators';
import useFetchOffers from '../../../core/apiHooks/useFetchOffers';
import { LOYALTY_OFFER_TYPES_SET, OFFER_TYPE_DOLLAR } from './constants';
import { selectAllTransmissionsKeysFromVehicles } from '../../../core/reducers/vehicles';
import { selectCurrentVehicleTransmissionKey } from '../../../core/reducers/currentVehicle';
import { selectSelectedIncentiveOffers } from '../../../core/reducers/offers';
import { useAppSelector } from '../../../core/utils';
import useOffersDictionaryConverter from '../AdditionalSavings/UseOffersDictionaryConverter';
var applyDictionaryValues = function (offer, getDictionaryValues) {
    var _a = getDictionaryValues(offer.name), tooltip = _a.tooltip, label = _a.label;
    return __assign(__assign({}, offer), { tooltip: tooltip, label: label || offer.name });
};
var applyDictionaryLoyaltyValues = function (offer, getDictionaryValues) {
    var _a = getDictionaryValues(offer.name), tooltip = _a.tooltip, label = _a.label;
    return __assign(__assign({}, offer), { tooltip: tooltip, label: label || offer.name });
};
var useIncentiveOffers = function (calculatorId, multi, shouldSkip) {
    var _a, _b;
    if (shouldSkip === void 0) { shouldSkip = false; }
    var getDictionaryValues = useOffersDictionaryConverter().getDictionaryValues;
    var isPrimary = calculatorId === primaryCalculatorId;
    var currentVehicleTransmissionKey = useAppSelector(selectCurrentVehicleTransmissionKey);
    var paymentMethod = useAppSelector(function (state) { return selectPaymentMethod(state, calculatorId); });
    var currentVehicleTransmissionKeys = useAppSelector(selectAllTransmissionsKeysFromVehicles);
    var termAndRate = useAppSelector(function (state) { return selectTermAndRate(state, calculatorId); });
    var selectedIncentiveOffers = useAppSelector(function (state) { return selectIncentiveOffers(state, calculatorId); });
    var selectedLoyaltyOffers = useAppSelector(function (state) { return selectLoyaltyOffer(state, calculatorId); });
    var selectedPrimaryIncentiveOffers = useAppSelector(function (state) { var _a; return paymentMethod ? (_a = selectSelectedIncentiveOffers(state, currentVehicleTransmissionKey, paymentMethod)) !== null && _a !== void 0 ? _a : [] : []; });
    var selectedPrimaryCalculatorLoyaltyKey = useAppSelector(selectPrimaryCalculatorLoyaltyOfferKey);
    var selectedOfferIds = isPrimary ? selectedPrimaryIncentiveOffers : selectedIncentiveOffers;
    var selectedLoyalty = (_a = (isPrimary ? selectedPrimaryCalculatorLoyaltyKey : selectedLoyaltyOffers)) !== null && _a !== void 0 ? _a : '';
    var _c = useFetchOffers({
        transmissionIds: multi ? currentVehicleTransmissionKeys : [currentVehicleTransmissionKey],
        currentTransmissionId: currentVehicleTransmissionKey,
        paymentMethod: paymentMethod,
        shouldSkip: shouldSkip,
    }), incentiveOffers = _c.incentiveOffers, loyaltyOffers = _c.loyaltyOffers, isSuccess = _c.isSuccess;
    var additionalSavingsOffers = incentiveOffers === null || incentiveOffers === void 0 ? void 0 : incentiveOffers.filter(function (o) { return o.type === OfferTypes.AdditionalSavings; });
    var filteredIncentiveOffers = incentiveOffers
        .filter(function (o) { return o.type !== OfferTypes.AdditionalSavings; })
        .map(function (o) { return (__assign(__assign({}, applyDictionaryValues(o, getDictionaryValues)), { isSelected: (selectedOfferIds === null || selectedOfferIds === void 0 ? void 0 : selectedOfferIds.includes(o.id)) || false })); });
    var stackableOffers = filteredIncentiveOffers.filter(function (o) { return o.type === OfferTypes.StackableRebate; });
    var nonStackableOffers = filteredIncentiveOffers.filter(function (o) { return o.type === OfferTypes.NonStackableRebate; });
    var loyaltyOfferAmount = ((_b = loyaltyOffers === null || loyaltyOffers === void 0 ? void 0 : loyaltyOffers.find(function (o) { return o.key === selectedLoyalty && o.type == OFFER_TYPE_DOLLAR; })) === null || _b === void 0 ? void 0 : _b.value) || 0;
    var provincialGovernmentIncentives = filteredIncentiveOffers.filter(function (o) { return o.type === OfferTypes.ProvincialGovernmentIncentive && (o.term === termAndRate || o.term === null); });
    var federalGovernmentIncentives = filteredIncentiveOffers.filter(function (o) { return o.type === OfferTypes.FederalGovernmentIncentive && (o.term === termAndRate || o.term === null); });
    var uniqueSelectedOfferIds = new Set(selectedOfferIds);
    var offersTotal = filteredIncentiveOffers.reduce(function (acc, offer) { return acc + (uniqueSelectedOfferIds.has(offer.id) ? offer.value : 0); }, loyaltyOfferAmount);
    var allAvailableOffers = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], stackableOffers, true), nonStackableOffers, true), additionalSavingsOffers, true), loyaltyOffers, true), federalGovernmentIncentives, true), provincialGovernmentIncentives, true);
    return {
        stackableOffers: stackableOffers,
        nonStackableOffers: nonStackableOffers,
        provincialGovernmentIncentives: provincialGovernmentIncentives,
        federalGovernmentIncentives: federalGovernmentIncentives,
        additionalSavingsOffers: additionalSavingsOffers,
        loyaltyOffers: loyaltyOffers === null || loyaltyOffers === void 0 ? void 0 : loyaltyOffers.map(function (o) { return (__assign(__assign({}, applyDictionaryLoyaltyValues(o, getDictionaryValues)), { isSelected: !!selectedLoyalty && selectedLoyalty === o.key })); }),
        offersTotal: offersTotal,
        currentVehicleTransmissionKey: currentVehicleTransmissionKey,
        paymentMethod: paymentMethod,
        selectedIncentiveOffers: selectedIncentiveOffers,
        selectedLoyaltyOffers: selectedLoyaltyOffers,
        allAvailableOffers: allAvailableOffers,
        isSuccess: isSuccess,
    };
};
export default useIncentiveOffers;
export var isLoyaltyOffer = function (type) { return LOYALTY_OFFER_TYPES_SET.has(type); };
export function filterOutNonIncentiveOffers(offers) {
    return offers
        .filter(function (_a) {
        var type = _a.type;
        return !isLoyaltyOffer(type);
    })
        .map(function (_a) {
        var id = _a.id;
        return Number(id);
    })
        .filter(Number);
}
